import React, { HTMLProps, MouseEventHandler, RefObject, useRef } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { IAppState } from 'src/store';
import { getRandomId } from 'src/utils';
import { isEmpty } from 'src/validations';
import './styles.scss';
import Element from '../Element';
import View from '../View';
import { Icon } from '..';

const Textarea: React.FC<TextareaProps> = ({
  children,
  errorMessage,
  label,
  className,
  containerClassName,
  textareaRef = null,
  iconName = '',
  onIconClick,
  ...props
}) => {
  const id = useRef<string>(`input-${getRandomId()}`);

  return (
    <Element id={id.current} errorMessage={errorMessage} label={label} className={containerClassName}>
      <View>
        <textarea
          id={id.current}
          className={cn(className, 'cmp-textarea', {
            'cmp-textarea--error': !isEmpty(errorMessage),
          })}
          ref={textareaRef}
          {...props}
        />
        {iconName && <Icon name={iconName} className="cmp-textarea__icon" onClick={onIconClick} />}
      </View>
    </Element>
  );
};

export type TextareaProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  HTMLProps<HTMLTextAreaElement> & {
    errorMessage?: string;
    containerClassName?: string;
    textareaRef?: RefObject<HTMLTextAreaElement>;
    iconName?: string;
    onIconClick?: MouseEventHandler<HTMLElement>;
  };

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Textarea);
